import React from 'react';
import { RecoveryActionDetails } from '../modules/recoveryActions';

class RecoveryActionTypesRouteHandler extends React.Component {
    render() {
        switch (this.props.params.recType) {
            default:
                return (
                    <RecoveryActionDetails
                        runId={this.props.params.id}
                        abnormalityId={this.props.params.abnormalityId}
                        abnormalityType={this.props.params.type}
                        recoveryActionId={this.props.params.recoveryActionId}
                        recoveryActionType={this.props.params.recType}
                    />
                );
        }
    }
}

export default RecoveryActionTypesRouteHandler;
